import { render, staticRenderFns } from "./group-accounts.vue?vue&type=template&id=468bc7fc&scoped=true"
import script from "./group-accounts.vue?vue&type=script&lang=js"
export * from "./group-accounts.vue?vue&type=script&lang=js"
import style0 from "./group-accounts.vue?vue&type=style&index=0&id=468bc7fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468bc7fc",
  null
  
)

export default component.exports